import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, of, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { EnterpriseAccessAreaDto } from '../interfaces/enterprise-access-area-dto';

/** The per-enterprise on/off switch of each RBAC product (IAM-2744). Not cached: the backend reads the database on every call. */
@Injectable({
    providedIn: 'root'
})
export class EnterpriseAccessAreaService {
    private readonly http = inject(HttpClient);

    private readonly baseUrl = environment.apiUrl + '/api/v1/enterprises';

    /**
     * Every RBAC product with its state, in configured order; [] when none is configured. A 404 also means none: the endpoint isn't
     * deployed yet, or the enterprise is outside the caller's security domain. Other failures still error.
     */
    getAccessAreas(enterpriseId: number): Observable<EnterpriseAccessAreaDto[]> {
        return this.http.get<EnterpriseAccessAreaDto[]>(`${this.baseUrl}/${enterpriseId}/access-areas`).pipe(
            catchError((error: HttpErrorResponse) => error.status === 404 ? of([]) : throwError(() => error))
        );
    }

    /** Turns one product on or off; repeating the current value is a no-op on the server. */
    setEnabled(enterpriseId: number, name: string, enabled: boolean): Observable<EnterpriseAccessAreaDto> {
        return this.http.put<EnterpriseAccessAreaDto>(`${this.baseUrl}/${enterpriseId}/access-areas/${encodeURIComponent(name)}`, { enabled });
    }
}
